import { default as _91slug_93msfiAekumQMeta } from "/app/pages/[slug].vue?macro=true";
import { default as _91slug_93cdf2dv6FbPMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as _91date_93gyfA9hshkYMeta } from "/app/pages/course/[slug]/[date].vue?macro=true";
import { default as indexuxDYZjEI3PMeta } from "/app/pages/course/[slug]/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_93h62tM3CXS2Meta } from "/app/pages/person/[slug].vue?macro=true";
import { default as _91slug_935Z1wMjbfraMeta } from "/app/pages/place/[slug].vue?macro=true";
import { default as articlesBTMQFuetMAMeta } from "/app/pages/preview/articles.vue?macro=true";
import { default as course_45datesj2Xm4CXNjbMeta } from "/app/pages/preview/course-dates.vue?macro=true";
import { default as coursesxjqlxzMjCOMeta } from "/app/pages/preview/courses.vue?macro=true";
import { default as peopleVGhh6e5Gx7Meta } from "/app/pages/preview/people.vue?macro=true";
import { default as placesqCtl3LhccqMeta } from "/app/pages/preview/places.vue?macro=true";
import { default as simple_45page1iE2CAJyY0Meta } from "/app/pages/preview/simple-page.vue?macro=true";
import { default as component_45stubTOq3NWgWLHMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubTOq3NWgWLH } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: _91slug_93msfiAekumQMeta?.name ?? "slug___pl-en",
    path: _91slug_93msfiAekumQMeta?.path ?? "/pl-en/:slug()",
    meta: _91slug_93msfiAekumQMeta || {},
    alias: _91slug_93msfiAekumQMeta?.alias || [],
    redirect: _91slug_93msfiAekumQMeta?.redirect,
    component: () => import("/app/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93msfiAekumQMeta?.name ?? "slug___pl-pl",
    path: _91slug_93msfiAekumQMeta?.path ?? "/pl-pl/:slug()",
    meta: _91slug_93msfiAekumQMeta || {},
    alias: _91slug_93msfiAekumQMeta?.alias || [],
    redirect: _91slug_93msfiAekumQMeta?.redirect,
    component: () => import("/app/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cdf2dv6FbPMeta?.name ?? "blog-slug___pl-en",
    path: _91slug_93cdf2dv6FbPMeta?.path ?? "/pl-en/blog/:slug()",
    meta: _91slug_93cdf2dv6FbPMeta || {},
    alias: _91slug_93cdf2dv6FbPMeta?.alias || [],
    redirect: _91slug_93cdf2dv6FbPMeta?.redirect,
    component: () => import("/app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cdf2dv6FbPMeta?.name ?? "blog-slug___pl-pl",
    path: _91slug_93cdf2dv6FbPMeta?.path ?? "/pl-pl/blog/:slug()",
    meta: _91slug_93cdf2dv6FbPMeta || {},
    alias: _91slug_93cdf2dv6FbPMeta?.alias || [],
    redirect: _91slug_93cdf2dv6FbPMeta?.redirect,
    component: () => import("/app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91date_93gyfA9hshkYMeta?.name ?? "course-slug-date___pl-en",
    path: _91date_93gyfA9hshkYMeta?.path ?? "/pl-en/course/:slug()/:date()",
    meta: _91date_93gyfA9hshkYMeta || {},
    alias: _91date_93gyfA9hshkYMeta?.alias || [],
    redirect: _91date_93gyfA9hshkYMeta?.redirect,
    component: () => import("/app/pages/course/[slug]/[date].vue").then(m => m.default || m)
  },
  {
    name: _91date_93gyfA9hshkYMeta?.name ?? "course-slug-date___pl-pl",
    path: _91date_93gyfA9hshkYMeta?.path ?? "/pl-pl/kurs/:slug()/:date()",
    meta: _91date_93gyfA9hshkYMeta || {},
    alias: _91date_93gyfA9hshkYMeta?.alias || [],
    redirect: _91date_93gyfA9hshkYMeta?.redirect,
    component: () => import("/app/pages/course/[slug]/[date].vue").then(m => m.default || m)
  },
  {
    name: indexuxDYZjEI3PMeta?.name ?? "course-slug___pl-en",
    path: indexuxDYZjEI3PMeta?.path ?? "/pl-en/course/:slug()",
    meta: indexuxDYZjEI3PMeta || {},
    alias: indexuxDYZjEI3PMeta?.alias || [],
    redirect: indexuxDYZjEI3PMeta?.redirect,
    component: () => import("/app/pages/course/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexuxDYZjEI3PMeta?.name ?? "course-slug___pl-pl",
    path: indexuxDYZjEI3PMeta?.path ?? "/pl-pl/kurs/:slug()",
    meta: indexuxDYZjEI3PMeta || {},
    alias: indexuxDYZjEI3PMeta?.alias || [],
    redirect: indexuxDYZjEI3PMeta?.redirect,
    component: () => import("/app/pages/course/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___pl-en",
    path: indexN6pT4Un8hYMeta?.path ?? "/pl-en",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___pl-pl",
    path: indexN6pT4Un8hYMeta?.path ?? "/pl-pl",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93h62tM3CXS2Meta?.name ?? "person-slug___pl-en",
    path: _91slug_93h62tM3CXS2Meta?.path ?? "/pl-en/person/:slug()",
    meta: _91slug_93h62tM3CXS2Meta || {},
    alias: _91slug_93h62tM3CXS2Meta?.alias || [],
    redirect: _91slug_93h62tM3CXS2Meta?.redirect,
    component: () => import("/app/pages/person/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93h62tM3CXS2Meta?.name ?? "person-slug___pl-pl",
    path: _91slug_93h62tM3CXS2Meta?.path ?? "/pl-pl/osoba/:slug()",
    meta: _91slug_93h62tM3CXS2Meta || {},
    alias: _91slug_93h62tM3CXS2Meta?.alias || [],
    redirect: _91slug_93h62tM3CXS2Meta?.redirect,
    component: () => import("/app/pages/person/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_935Z1wMjbfraMeta?.name ?? "place-slug___pl-en",
    path: _91slug_935Z1wMjbfraMeta?.path ?? "/pl-en/place/:slug()",
    meta: _91slug_935Z1wMjbfraMeta || {},
    alias: _91slug_935Z1wMjbfraMeta?.alias || [],
    redirect: _91slug_935Z1wMjbfraMeta?.redirect,
    component: () => import("/app/pages/place/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_935Z1wMjbfraMeta?.name ?? "place-slug___pl-pl",
    path: _91slug_935Z1wMjbfraMeta?.path ?? "/pl-pl/lokalizacja/:slug()",
    meta: _91slug_935Z1wMjbfraMeta || {},
    alias: _91slug_935Z1wMjbfraMeta?.alias || [],
    redirect: _91slug_935Z1wMjbfraMeta?.redirect,
    component: () => import("/app/pages/place/[slug].vue").then(m => m.default || m)
  },
  {
    name: articlesBTMQFuetMAMeta?.name ?? "preview-articles___pl-en",
    path: articlesBTMQFuetMAMeta?.path ?? "/pl-en/preview/articles",
    meta: articlesBTMQFuetMAMeta || {},
    alias: articlesBTMQFuetMAMeta?.alias || [],
    redirect: articlesBTMQFuetMAMeta?.redirect,
    component: () => import("/app/pages/preview/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesBTMQFuetMAMeta?.name ?? "preview-articles___pl-pl",
    path: articlesBTMQFuetMAMeta?.path ?? "/pl-pl/podglad/artykuly",
    meta: articlesBTMQFuetMAMeta || {},
    alias: articlesBTMQFuetMAMeta?.alias || [],
    redirect: articlesBTMQFuetMAMeta?.redirect,
    component: () => import("/app/pages/preview/articles.vue").then(m => m.default || m)
  },
  {
    name: course_45datesj2Xm4CXNjbMeta?.name ?? "preview-course-dates___pl-en",
    path: course_45datesj2Xm4CXNjbMeta?.path ?? "/pl-en/preview/course-dates",
    meta: course_45datesj2Xm4CXNjbMeta || {},
    alias: course_45datesj2Xm4CXNjbMeta?.alias || [],
    redirect: course_45datesj2Xm4CXNjbMeta?.redirect,
    component: () => import("/app/pages/preview/course-dates.vue").then(m => m.default || m)
  },
  {
    name: course_45datesj2Xm4CXNjbMeta?.name ?? "preview-course-dates___pl-pl",
    path: course_45datesj2Xm4CXNjbMeta?.path ?? "/pl-pl/podglad/daty-kursu",
    meta: course_45datesj2Xm4CXNjbMeta || {},
    alias: course_45datesj2Xm4CXNjbMeta?.alias || [],
    redirect: course_45datesj2Xm4CXNjbMeta?.redirect,
    component: () => import("/app/pages/preview/course-dates.vue").then(m => m.default || m)
  },
  {
    name: coursesxjqlxzMjCOMeta?.name ?? "preview-courses___pl-en",
    path: coursesxjqlxzMjCOMeta?.path ?? "/pl-en/preview/courses",
    meta: coursesxjqlxzMjCOMeta || {},
    alias: coursesxjqlxzMjCOMeta?.alias || [],
    redirect: coursesxjqlxzMjCOMeta?.redirect,
    component: () => import("/app/pages/preview/courses.vue").then(m => m.default || m)
  },
  {
    name: coursesxjqlxzMjCOMeta?.name ?? "preview-courses___pl-pl",
    path: coursesxjqlxzMjCOMeta?.path ?? "/pl-pl/podglad/kursy",
    meta: coursesxjqlxzMjCOMeta || {},
    alias: coursesxjqlxzMjCOMeta?.alias || [],
    redirect: coursesxjqlxzMjCOMeta?.redirect,
    component: () => import("/app/pages/preview/courses.vue").then(m => m.default || m)
  },
  {
    name: peopleVGhh6e5Gx7Meta?.name ?? "preview-people___pl-en",
    path: peopleVGhh6e5Gx7Meta?.path ?? "/pl-en/preview/people",
    meta: peopleVGhh6e5Gx7Meta || {},
    alias: peopleVGhh6e5Gx7Meta?.alias || [],
    redirect: peopleVGhh6e5Gx7Meta?.redirect,
    component: () => import("/app/pages/preview/people.vue").then(m => m.default || m)
  },
  {
    name: peopleVGhh6e5Gx7Meta?.name ?? "preview-people___pl-pl",
    path: peopleVGhh6e5Gx7Meta?.path ?? "/pl-pl/podglad/ludzie",
    meta: peopleVGhh6e5Gx7Meta || {},
    alias: peopleVGhh6e5Gx7Meta?.alias || [],
    redirect: peopleVGhh6e5Gx7Meta?.redirect,
    component: () => import("/app/pages/preview/people.vue").then(m => m.default || m)
  },
  {
    name: placesqCtl3LhccqMeta?.name ?? "preview-places___pl-en",
    path: placesqCtl3LhccqMeta?.path ?? "/pl-en/preview/places",
    meta: placesqCtl3LhccqMeta || {},
    alias: placesqCtl3LhccqMeta?.alias || [],
    redirect: placesqCtl3LhccqMeta?.redirect,
    component: () => import("/app/pages/preview/places.vue").then(m => m.default || m)
  },
  {
    name: placesqCtl3LhccqMeta?.name ?? "preview-places___pl-pl",
    path: placesqCtl3LhccqMeta?.path ?? "/pl-pl/podglad/lokalizacje",
    meta: placesqCtl3LhccqMeta || {},
    alias: placesqCtl3LhccqMeta?.alias || [],
    redirect: placesqCtl3LhccqMeta?.redirect,
    component: () => import("/app/pages/preview/places.vue").then(m => m.default || m)
  },
  {
    name: simple_45page1iE2CAJyY0Meta?.name ?? "preview-simple-page___pl-en",
    path: simple_45page1iE2CAJyY0Meta?.path ?? "/pl-en/preview/simple-page",
    meta: simple_45page1iE2CAJyY0Meta || {},
    alias: simple_45page1iE2CAJyY0Meta?.alias || [],
    redirect: simple_45page1iE2CAJyY0Meta?.redirect,
    component: () => import("/app/pages/preview/simple-page.vue").then(m => m.default || m)
  },
  {
    name: simple_45page1iE2CAJyY0Meta?.name ?? "preview-simple-page___pl-pl",
    path: simple_45page1iE2CAJyY0Meta?.path ?? "/pl-pl/podglad/podstrona",
    meta: simple_45page1iE2CAJyY0Meta || {},
    alias: simple_45page1iE2CAJyY0Meta?.alias || [],
    redirect: simple_45page1iE2CAJyY0Meta?.redirect,
    component: () => import("/app/pages/preview/simple-page.vue").then(m => m.default || m)
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/sitemap.xml",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/pl-sitemap-sitemap.xml",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/en-sitemap-sitemap.xml",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  }
]